export interface LifecycleStage {
  id: string;
  translationKey: string;
}

export const lifecycleStages: LifecycleStage[] = [
  { id: 'Visitor', translationKey: 'LIFECYCLE_STAGE.VISITOR' },
  { id: 'Lead', translationKey: 'LIFECYCLE_STAGE.LEAD' },
  { id: 'Marketing qualified lead', translationKey: 'LIFECYCLE_STAGE.MARKETING_QUALIFIED_LEAD' },
  { id: 'Sales accepted lead', translationKey: 'LIFECYCLE_STAGE.SALES_ACCEPTED_LEAD' },
  { id: 'Sales qualified lead', translationKey: 'LIFECYCLE_STAGE.SALES_QUALIFIED_LEAD' },
  { id: 'Prospect', translationKey: 'LIFECYCLE_STAGE.PROSPECT' },
  { id: 'Customer', translationKey: 'LIFECYCLE_STAGE.CUSTOMER' },
  { id: 'Former customer', translationKey: 'LIFECYCLE_STAGE.FORMER_CUSTOMER' },
];
